"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoliaContext = void 0;
const helper_1 = require("../helper");
const algoliaContext = (0, helper_1.createAlgoliaContext)();
exports.algoliaContext = algoliaContext;
//# sourceMappingURL=algoliaContext.js.map